import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-global',
  templateUrl: './loading-global.component.html',
  styleUrls: ['./loading-global.component.scss']
})
export class LoadingGlobalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
